export enum RESET_PWD_STEP {
  USERNAME,
  VERIFY_CODE,
  PASSWORD,
}

export const SSO_LOGIN_ERR_MSG = {
  E0010035: '您在当前企业已被停用，请联系管理员', // 人员状态不可用（单个企业情况下）
};
